import { myGet, myPost, handlePostError } from '../utils/myAxios'
import setAuthorizationToken from '../utils/setAuthorizationToken'
import { servAddr } from '../servAddr'

export function logout() {
  return dispatch => {
    localStorage.removeItem('authToken');
    setAuthorizationToken(false);
    dispatch({type:'SET_CURRENT_USER',user:{}});
    dispatch({type:'USER_LOGOUT'});
  }
}

export function becomeBetter(cb = () => {}){
  return dispatch => {
    myPost(dispatch, servAddr + 'become_better').then(res => {
      cb();
      dispatch({type: "SAVING_DATA_STATE", state: false});
    }, err => {
      handlePostError(dispatch, err, cb);
    });
  }
}

export function login(data, cb = () => {}) {
  return dispatch => {
    return myPost(dispatch, servAddr + 'logreg', data).then(res => {
      dispatch({type: "SAVING_DATA_STATE", state: false});
      localStorage.setItem('authToken', res.data.token);
      localStorage.setItem('login', res.data.user.user_login);
      setAuthorizationToken(res.data.user.user_login + ' ' + res.data.token);
      dispatch({type:'SET_CURRENT_USER',user:res.data.user});
      dispatch(fetchUser());
      cb();
    }, err => {
      handlePostError(dispatch, err, cb);
    });
  }
}

export function fetchUser() {
  return dispatch => {
    myGet(dispatch, servAddr + 'userdata').then(res => {
      dispatch({type:'SET_CURRENT_USER',user:res.data.info});
      dispatch({type:'FETCH_MENU',menu:res.data.menu});
      dispatch({type:'FETCH_SETS',sets:res.data.sets});
      dispatch({type:'FETCH_COMPRIGHTS',comprights:res.data.comprights});
      dispatch({type:'FETCH_USER_RIGHTS',rights:res.data.rights});
      dispatch({type: "FETCH_SETTINGS", payload: res.data.settings});
      if(res.data.settings.hasOwnProperty('default_order_stts_filter')){
        var filter = res.data.settings.default_order_stts_filter.split(',');
        for(var i=0; i<filter.length; i++) {
          filter[i] = parseInt(filter[i], 10);
        }
        dispatch({type: "FILTER_ORDERS", filter: filter});
      }
    }, err => {
      if (err.response.status === 403) {
        localStorage.removeItem('authToken');
        setAuthorizationToken(false);
        dispatch({type:'SET_CURRENT_USER',user:{}});
        dispatch({type:'USER_LOGOUT'});
      }
    });
  }
}

export function editUser(data, cb = () => {}) {
  return dispatch => {
    myPost(dispatch, servAddr + 'userdata', data).then((response) => {
      cb();
      dispatch({type:'EDIT_CURRENT_USER',user:data});
    }, err => {
      handlePostError(dispatch, err, cb);
    });
  }
}

export function changePass(data, cb = () => {}) {
  return dispatch => {
    myPost(dispatch, servAddr + 'userdata', data).then((response) => {
      dispatch({
        type: "ADD_FLASH_MESSAGE",
        message:{type:'success',text: 'Пароль успешно изменен'}
      });
      cb();
    }, err => {
      handlePostError(dispatch, err, cb);
    });
  }
}



// WEBPACK FOOTER //
// ./src/actions/authActions.js